import { createSlice } from '@reduxjs/toolkit';
import { CalendarState, Calendar } from './calenderTypes';

import { createGoogleEvent, createTask, fetchAllTask, getTaskByEmployeeId } from './calendarAction';


const initialState: CalendarState = {
    calendar: [],
    selectedCalendar: undefined,
    employeeTasks: [],
    googleEvent: undefined,
    loadingStates: {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
        fetchByEmployeeId: false,
        meetLink: false
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
        fetchByEmployeeId: undefined,
        meetLink: undefined,
    },
}


const calendarSlice = createSlice({
    name: 'calendar',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(createTask.pending, (state) => {
                state.loadingStates.create = true;
                state.errors.create = undefined;
            })
            .addCase(createTask.fulfilled, (state, action) => {
                state.loadingStates.create = false;
                state.calendar.push(action.payload);
            })
            .addCase(createTask.rejected, (state, action) => {
                state.loadingStates.create = false;
                state.errors.create = action.payload as string;
            })
            .addCase(getTaskByEmployeeId.pending, (state) => {
                state.loadingStates.fetchByEmployeeId = true;
                state.errors.fetchByEmployeeId = undefined;
            })
            .addCase(getTaskByEmployeeId.fulfilled, (state, action) => {
                state.loadingStates.fetchByEmployeeId = false;
                state.employeeTasks = action.payload.data;
            })
            .addCase(getTaskByEmployeeId.rejected, (state, action) => {
                state.loadingStates.fetchByEmployeeId = false;
                state.errors.fetchByEmployeeId = action.payload as string;
            })

            .addCase(fetchAllTask.pending, (state) => {
                state.loadingStates.fetchAll = true;
                state.errors.fetchAll = undefined;
            })
            .addCase(fetchAllTask.fulfilled, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.calendar = action.payload.data;
            })
            .addCase(fetchAllTask.rejected, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.errors.fetchAll = action.payload as string;
            })

            // Create Meet Link
            .addCase(createGoogleEvent.pending, (state) => {
                state.loadingStates.meetLink = true;
            })
            .addCase(createGoogleEvent.fulfilled, (state, action) => {
                state.loadingStates.meetLink = false;
                state.googleEvent = action.payload;
            })
            .addCase(createGoogleEvent.rejected, (state, action) => {
                state.loadingStates.meetLink = false;
                state.errors.meetLink = action.payload as string;
            });
    },
})


export default calendarSlice.reducer;


